function log(...args) {
  console.log(...args);
}

log.i = process.env.REACT_APP_ENVIRONMENT === 'production' ? () => {} : console.info;

log.e = process.env.REACT_APP_ENVIRONMENT === 'production' ? () => {} : console.error;

export default log;
